import { render, staticRenderFns } from "./CustomComponents.vue?vue&type=template&id=290260f8&"
import script from "./CustomComponents.vue?vue&type=script&lang=ts&"
export * from "./CustomComponents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports